export class ComponentUnsyncedVwMdl {
    public Id: number;
    public ComponentId: number;
    public Component: string;
    public Position: string;
    public Reading: number;
  public Image: string;
  public Images: string[] = [];
    public Comments: string;
    public Side: number;
  public IsFlagged: boolean;
  public ComponentTypeId: number;
  public Recommendations: string;
  public ActionType: number;
}
export class JobSiteDetailsUnsyncedVwMdl {
    public Id: number;
    public JobSiteName: string;
    public TrakSagLeft: number;
    public TrakSagRight: number;
    public DryJointsLeft: number;
    public DryJointsRight: number;
    public ExtCannonLeft: number;
    public ExtCannonRight: number;
    public ScallopMeasurementLeft: number;
    public ScallopMeasurementRight: number;
    public Impact: string;
    public Abrasive: string;
    public Moisture: string;
    public Packing: string;
    public JobSiteNotes: string;
}
export class InspectionUnsyncedVwMdl {
    public Id: number;
    public MatchedEquipmentId: number;
    public MobileEqId: number;
    public Customer: string;
    public Serial: string;
    public UnitNumber: string;
    public Model: string;
    public InspectionDate: string;
    public SMU: number;
    public InspectionNotes: string;
    public JobSiteDetails: JobSiteDetailsUnsyncedVwMdl = new JobSiteDetailsUnsyncedVwMdl();
  public InspectionDetails: ComponentUnsyncedVwMdl[] = [];
  public MblAdditionalObservationsVM: MblAdditionalObservationsVM[] = [];
}
export class MblAdditionalObservationsVM {
  public Id: number;
  public Description: string;
  public Answer: string[];
  public Images: string[];
  public Comment: string;
}
